import FunnelSearchList from './FunnelSearchList';

export default FunnelSearchList;
